
//===========================================
// THIS FILE IS AUTO-GENERATED FROM TEMPLATE. DO NOT EDIT IT DIRECTLY UNLESS YOU ALSO EDIT THE CORRESPONDING FILE IN packages/template
//===========================================
import { urlString } from "@hexclave/shared/dist/utils/urls";
import { defaultBaseUrl } from "../lib/hexclave-app/apps/implementations/common";

export function getConvexProvidersConfig(options: {
  baseUrl?: string,
  projectId: string,
}) {
  const baseUrl = options.baseUrl || defaultBaseUrl;
  const projectId = options.projectId;
  return [
    {
      type: "customJwt",
      issuer: new URL(urlString`/api/v1/projects/${projectId}`, baseUrl),
      jwks: new URL(urlString`/api/v1/projects/${projectId}/.well-known/jwks.json`, baseUrl),
      algorithm: "ES256",
    },
    {
      type: "customJwt",
      issuer: new URL(urlString`/api/v1/projects-anonymous-users/${projectId}`, baseUrl),
      jwks: new URL(urlString`/api/v1/projects/${projectId}/.well-known/jwks.json?include_anonymous=true`, baseUrl),
      algorithm: "ES256",
    },
  ];
}
